export default __webpack_public_path__ + "static/media/POLYGON.1140771b.png";